import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaLightbulb,
  FaSearch,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaEye
} from "react-icons/fa";
import { toast } from "react-toastify";
import api from "../utils/api";
import "./MySuggestions.css";

const MySuggestions = () => {

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [suggestions, setSuggestions] = useState([]);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");

  useEffect(() => {
    fetchSuggestions();
  }, []);

  const fetchSuggestions = async () => {

    try {

      setLoading(true);

      const res = await api.get("/suggestions/my");

      setSuggestions(res.data?.data || []);

    } catch (err) {

      console.error(err);
      toast.error("Failed to load suggestions.");

    } finally {

      setLoading(false);

    }

  };

  const filteredSuggestions = useMemo(() => {

    return suggestions.filter((item) => {

      const matchesSearch =
        item.title?.toLowerCase().includes(search.toLowerCase()) ||
        item.category?.toLowerCase().includes(search.toLowerCase()) ||
        item.description?.toLowerCase().includes(search.toLowerCase());

      const matchesStatus =
        statusFilter === "ALL" ||
        item.status === statusFilter;

      return matchesSearch && matchesStatus;

    });

  }, [suggestions, search, statusFilter]);

  const stats = {

    total: suggestions.length,

    submitted: suggestions.filter(
      s => s.status === "SUBMITTED"
    ).length,

    review: suggestions.filter(
      s => s.status === "UNDER_REVIEW"
    ).length,

    implemented: suggestions.filter(
      s => s.status === "IMPLEMENTED"
    ).length

  };

  const getStatusClass = (status) => {

    switch (status) {

      case "SUBMITTED":
        return "status submitted";

      case "UNDER_REVIEW":
        return "status review";

      case "ACCEPTED":
        return "status accepted";

      case "IMPLEMENTED":
        return "status implemented";

      case "REJECTED":
        return "status rejected";

      default:
        return "status";
    }

  };

  return (

    <div className="my-suggestions-page">

      <div className="my-suggestions-container">

        <button
          className="suggestion-back-btn"
          onClick={() => navigate("/dashboard")}
        >
          <FaArrowLeft />
          Back to Dashboard
        </button>

        <div className="page-header">

          <div className="page-title">

            <FaLightbulb className="title-icon" />

            <div>

              <h2>My Suggestions</h2>

              <p>
                Track all your submitted suggestions and their progress.
              </p>

            </div>

          </div>

        </div>

        <div className="stats-grid">

          <div className="stat-card">

            <h3>{stats.total}</h3>

            <span>Total Suggestions</span>

          </div>

          <div className="stat-card">

            <h3>{stats.submitted}</h3>

            <span>Submitted</span>

          </div>

          <div className="stat-card">

            <h3>{stats.review}</h3>

            <span>Under Review</span>

          </div>

          <div className="stat-card">

            <h3>{stats.implemented}</h3>

            <span>Implemented</span>

          </div>

        </div>

        <div className="toolbar">

          <div className="search-box">

            <FaSearch />

            <input
              type="text"
              placeholder="Search suggestions..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

          </div>

          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >

            <option value="ALL">All Status</option>
            <option value="SUBMITTED">Submitted</option>
            <option value="UNDER_REVIEW">Under Review</option>
            <option value="ACCEPTED">Accepted</option>
            <option value="IMPLEMENTED">Implemented</option>
            <option value="REJECTED">Rejected</option>

          </select>

        </div>

                {loading ? (

          <div className="loading-state">

            <h3>Loading suggestions...</h3>

          </div>

        ) : filteredSuggestions.length === 0 ? (

          <div className="empty-state">

            <FaLightbulb className="empty-icon" />

            <h3>No Suggestions Found</h3>

            <p>
              You haven't submitted any suggestions yet or no suggestions
              match your search.
            </p>

            <button
              className="submit-new-btn"
              onClick={() => navigate("/suggestion")}
            >
              Share a Suggestion
            </button>

          </div>

        ) : (

          <div className="suggestions-grid">

            {filteredSuggestions.map((item) => (

              <div
                key={item.id}
                className="suggestion-card"
              >

                <div className="card-header">

                  <div>

                    <h3>{item.title}</h3>

                    <p className="category">
                      {item.category}
                    </p>

                  </div>

                  <span className={getStatusClass(item.status)}>
                    {item.status.replace("_", " ")}
                  </span>

                </div>

                <p className="description">

                  {item.description
  ? item.description.length > 140
    ? item.description.substring(0, 140) + "..."
    : item.description
  : "No description provided"}

                </p>

                <div className="card-footer">

                  <div className="footer-item">

                    <FaMapMarkerAlt />

                    <span>
                      {item.location || "Location not provided"}
                    </span>

                  </div>

                  <div className="footer-item">

                    <FaCalendarAlt />

                    <span>
                     {item.createdAt
  ? new Date(item.createdAt).toLocaleDateString()
  : "-"}
                    </span>

                  </div>

                </div>

                <button
  className="view-btn"
  onClick={() => navigate(`/suggestion/${item.id}`)}
>
  <FaEye />
  View Details
</button>

              </div>

            ))}

          </div>

        )}

      </div>

    </div>

  );

};

export default MySuggestions;